module.exports = __webpack_public_path__ + "img/c07_unitcaravan_Normal_ua.d9ab3c51.webp";